// icons
import { MdCode, MdTableChart, MdDateRange, MdPages, MdDraw, MdSpeed, MdPersonAdd, MdWidgets, MdWebAsset, MdOutlineWavingHand, MdPerson } from "react-icons/md";

const templates = {
    id: 'templates-group',
    type: 'group',
    roles: [1],
    breadcrumbs: false,
    children: [
      {
        id: 'templates',
        title: "Templates",
        type: 'collapse',
        icon: MdCode,
        children: [
          {
            id: 'table-list-standard',
            title: "Table List Standard",
            type: 'item',
            breadcrumbs: false,
            icon: MdTableChart,
            url: '/templates/table-list-standard'
          },
          {
            id: 'saludo',
            title: "Saludo",
            type: 'item',
            breadcrumbs: false,
            icon: MdOutlineWavingHand,
            url: '/templates/saludo'
          },
          {
            id: 'table-list-date-range',
            title: "Table List Date Range",
            type: 'item',
            breadcrumbs: false,
            icon: MdDateRange,
            url: '/templates/table-list-date-range'
          },
          {
            id: 'simple-page',
            title: "Simple Page",
            type: 'item',
            breadcrumbs: false,
            icon: MdPages,
            url: '/templates/simple-page'
          },
          {
            id: 'esignature',
            title: "Esignature",
            type: 'item',
            breadcrumbs: false,
            icon: MdDraw,
            url: '/templates/esignature'
          },
          {
            id: 'widget-indicador-minmax',
            title: "Widget Indicador MinMax",
            type: 'item',
            breadcrumbs: false,
            icon: MdSpeed,
            url: '/templates/widget-indicador-minmax'
          },
          {
            id: 'table-list-selector',
            title: "Table List Selector",
            type: 'item',
            breadcrumbs: false,
            icon: MdTableChart,
            url: '/templates/table-list-selector'
          },
          {
            id: 'alta-beneficiario',
            title: "Alta Beneficiario",
            type: 'item',
            breadcrumbs: false,
            icon: MdPersonAdd,
            url: '/templates/alta-beneficiario'
          },
          {
            id: 'single-components',
            title: "Single Components",
            type: 'item',
            breadcrumbs: false,
            icon: MdWidgets,
            url: '/templates/single-components'
          },
          {
            id: 'table-selector-modal',
            title: "Table Selector Modal",
            type: 'item',
            breadcrumbs: false,
            icon: MdTableChart,
            url: '/templates/table-selector-modal'
          },
          {
            id: 'modals',
            title: "Modals",
            type: 'item',
            breadcrumbs: false,
            icon: MdWebAsset,
            url: '/templates/modals'
          },
          {
            id: 'modal-form-dummy',
            title: "Modal Form Dummy",
            type: 'item',
            breadcrumbs: false,
            icon: MdWebAsset,
            url: '/templates/modal-form-dummy'
          },
          {
            id: 'cliente',
            title: "Cliente",
            type: 'item',
            breadcrumbs: false,
            icon: MdPerson,
            roles: [1],
            url: '/templates/cliente'
          }
        ]
      }
    ]
  };

export default templates;
